import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center q-gutter-x-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlatformDropdown = _resolveComponent("PlatformDropdown")!
  const _component_PlatformToggleButton = _resolveComponent("PlatformToggleButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platformsWithCategories, (platform) => {
      return (_openBlock(), _createBlock(_component_PlatformDropdown, {
        key: platform.id,
        platform: platform,
        categories: _ctx.categoriesForPlatform(platform.id),
        "is-active": _ctx.isActive(platform.id),
        "all-selected": _ctx.isAllPostsSelected(platform.id),
        "selected-category-ids": _ctx.getSelectedCategoryIds(platform.id),
        "selected-lifecycle-statuses": _ctx.lifecycleStatuses,
        onTogglePlatform: ($event: any) => (_ctx.togglePlatform(platform.id)),
        onToggleAllCategories: ($event: any) => (_ctx.toggleAllPosts(platform.id)),
        onToggleCategory: ($event: any) => (_ctx.toggleCategory($event, platform.id)),
        onLifecycleChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('lifecycle-change', $event)))
      }, null, 8, ["platform", "categories", "is-active", "all-selected", "selected-category-ids", "selected-lifecycle-statuses", "onTogglePlatform", "onToggleAllCategories", "onToggleCategory"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platformsWithoutCategories, (platform) => {
      return (_openBlock(), _createBlock(_component_PlatformToggleButton, {
        key: platform.id,
        platform: platform,
        "is-active": _ctx.isActive(platform.id),
        onToggle: ($event: any) => (_ctx.togglePlatform(platform.id))
      }, null, 8, ["platform", "is-active", "onToggle"]))
    }), 128))
  ]))
}